/* eslint-disable complexity */
import { ChatMessageType } from "@jd/jdee.im.sdk/lib/es/protocol/message/Type";
import { generateMessageId } from "@jd/jdee.im.sdk/lib/es/utils/utils";
import log from "@/utils/logger";
import i18n from "i18next";
import { message as toast } from "antd";
import ImService from "@/server/ImService";

import { FocusSDK, getClientType, isFocusEnv } from "@/utils";
import { Employee, SysChatMessage, ChatMessageBody, SessionType } from "@/types/chat";
import {
  AVSDK,
  BasicUserInfo,
  MeetingInfoType,
  sessionStateContentMap,
  SessionStateEnum,
  LiveInfoType,
  PreJoinCode
} from "./common";
import { DeeplinkPathEnum } from "@/components/DeeplinkHandler/DeeplinkEvent";
import dayjs from "dayjs";
import bus from "@/utils/bus";
import {
  getConferenceByCode,
  createMeeting as requestCreateMeeting,
  getJRTCToken,
  conferenceCall,
  sendConferenceCardMsg,
  queryLiveInfo,
  preJoin
} from "@/api/meeting";
import { MeetingPlatform } from "@/types/common";
import { getNoticeBot, sendNoticeCardMessage } from "@/api/chat";

import { getStatus as getJDMeetStatus } from "@/components/MeetingJD/utils";
import { getStatus as getXYLinkMeetStatus } from "@/components/MeetingXYLink/utils";
import { joinCloudLink } from "@/components/MeetingCloudLink/utils";
import cache from "@/utils/cache";
import {
  getZoomStatus,
  joinMeeting as joinZoomMeeting,
  leaveMeeting
} from "@/components/Meeting/utils";
import PostMessageService from "@/utils/postMessageClient";
import { getCloudLinkStatus, CloudLinkStatusEnum } from "@/components/MeetingCloudLink/Connector";
import { WebviewKernel } from "@/services/AppStore";
import CHAT_NOTICE from "@/contant/chat";
import { crossAppSwitch } from "@/utils/tools";
import Axios from "axios";
import { syncConfirmNew } from "@/utils/syncConfirm";
import getAppEntry from "@/utils/entry";
import { updateMinutesOpenTime } from "@/api/meetingRecord";

const isBigScreen = process.env.REACT_APP_X_FLAG === "olympic";
const logger = log.getLogger("meeting");

const handledMessage: string[] = [];
const deepLinkPath = {
  [AVSDK.HUAWEI]: "cloudlink",
  [AVSDK.JBRTC]: "joymeeting",
  [AVSDK.ZOOM]: "joymeeting",
  [AVSDK.XYLINK]: "joymeeting"
};

export const avsdkNameMap = {
  [AVSDK.HUAWEI]: "信创视频会议",
  [AVSDK.JBRTC]: "智能会议",
  [AVSDK.XYLINK]: "政务视频会议",
  [AVSDK.ZOOM]: "视频会议"
};

export function getAppKey(avsdk: AVSDK) {
  if (avsdk === AVSDK.JBRTC) {
    return "ySpQy1vu3T5jTG6xld8P";
    // return "iZ1ZpJzbzAdprQiPoImD";
  } else if (avsdk === AVSDK.HUAWEI) {
    return "4iJ0jfgCLTXdz6YED06W";
  } else if (avsdk === AVSDK.XYLINK) {
    return "vbNWhC0nRvvN1q3nM5Zy";
  }
  return "jif5OZ0gf6qNotBVAraI";
}

export const WEB_SDK_LIST = [AVSDK.JBRTC];

export function getPlatform(avsdk: AVSDK): MeetingPlatform {
  if (avsdk === AVSDK.JBRTC) {
    return MeetingPlatform.JBRTC;
  }
  if (avsdk === AVSDK.HUAWEI) {
    return MeetingPlatform.HW;
  }
  if (avsdk === AVSDK.XYLINK) {
    return MeetingPlatform.XYLINK;
  }
  return MeetingPlatform.CLOUD_UNION;
}

export function getAvsdk(platform: MeetingPlatform): AVSDK | null {
  if (platform === MeetingPlatform.JBRTC) {
    return AVSDK.JBRTC;
  }
  if (platform === MeetingPlatform.HW) {
    return AVSDK.HUAWEI;
  }
  if (platform === MeetingPlatform.XYLINK) {
    return AVSDK.XYLINK;
  }
  if (platform === MeetingPlatform.CLOUD_UNION) {
    return AVSDK.ZOOM;
  }
  return null;
}

let currentMeetingInfo: {
  [index: string]: any;
} = {
  [AVSDK.HUAWEI]: null,
  [AVSDK.XYLINK]: null,
  [AVSDK.JBRTC]: null,
  [AVSDK.ZOOM]: null
};
export function getCurrentMeetingInfo(avsdk: AVSDK) {
  return currentMeetingInfo[avsdk];
}

export function getBigScreenMeetingTopic() {
  if (!isBigScreen) {
    return "线上会议";
  }
  return JSON.parse(FocusSDK.getConfigData())?.settings?.meetingTopic || "调度会议";
}

export function setCurrentMeetingInfo(avsdk: AVSDK, meetingInfo: any) {
  currentMeetingInfo[avsdk] = meetingInfo;
  logger.debug("currentMeetingInfo", currentMeetingInfo);
}

export async function showHomeCreate(avsdk: AVSDK, list: any[], history: any) {
  return new Promise((resolve, reject) => {
    if (!isFocusEnv()) {
      reject(new Error("暂不支持网页端"));
      return;
    }
    if (avsdk === AVSDK.ZOOM) {
      // 没有工作台，打开侧边栏meeting页
      if (!crossAppSwitch("threeApp")) {
        history.push({
          pathname: "/meeting",
          state: {
            query: "action=homeCreate"
          }
        });
        bus.once("wv:home:create", () => {
          sendToWebView("wv:home:create", list);
          resolve(true);
        });
        return;
      }
      history.push({
        pathname: "/third_apps"
      });
      const openApp = () => {
        bus.emit("openThirdApp", {
          applicationKey: getNoticeBot(avsdk),
          homeUrl: "/meeting?action=homeCreate",
          webviewKernel: WebviewKernel.NewWindow,
          name,
          icon: "",
          version: "1.0.0"
        });
        bus.off("thirdapp:ready", openApp);
        clearTimeout(timeout);
        clearTimeout(delay);
        bus.once("wv:home:create", () => {
          sendToWebView("wv:home:create", list);
          resolve(true);
        });
      };
      bus.once("thirdapp:ready", openApp);
      const delay = setTimeout(() => {
        openApp();
      }, 1000);
      const timeout = setTimeout(() => {
        bus.off("thirdapp:ready", openApp);
      }, 5000);
    } else {
      reject(new Error("不支持的类型"));
    }
  });
}

// 这个方法目前只有冬奥大屏的代码会调用，如果修改逻辑，不报错先不用管
export async function createMeeting(
  avsdk: AVSDK,
  {
    meetingPassword = "",
    topic,
    isaudiooff = true,
    isvideooff = true
  }: {
    meetingPassword?: string;
    topic: string;
    isaudiooff?: boolean;
    isvideooff?: boolean;
  },
  toUsers?: BasicUserInfo[]
) {
  if (!isFocusEnv() && !WEB_SDK_LIST.includes(avsdk)) {
    return;
  }
  const timeout = setTimeout(() => {
    return Promise.reject(new Error("创建会议超时"));
  }, 30000);
  const currentStatus = await getStatus(avsdk);
  if (currentStatus) {
    return Promise.reject(new Error("会议进行中"));
  }
  const user = await ImService.getInstance().getCurrentEmployee();
  if (!user || !user.userId) {
    return Promise.reject(new Error("获取用户信息失败"));
  }

  const [meetingInfo, err] = await requestCreateMeeting({
    startTime: (dayjs().valueOf() + 5000).toString(),
    duration: 2,
    topic: topic,
    password: meetingPassword,
    platform: getPlatform(avsdk),
    participantIds: [
      {
        realName: user.name || "",
        teamId: user.teamId || "",
        userId: user.userId || "",
        appId: user.app || "",
        headImg: user.avatar || ""
      }
    ]
  });
  if (err || !meetingInfo) {
    return Promise.reject(new Error(err || ""));
  }
  try {
    if (avsdk === AVSDK.HUAWEI) {
      await joinCloudLink(user.userId, {
        meetingNumber: meetingInfo.meetingId,
        username: user.name || "",
        password: meetingPassword,
        isvideooff: isvideooff,
        isaudiooff: isaudiooff
      });
    } else if (avsdk === AVSDK.ZOOM) {
      await joinZoomMeeting(
        {
          meetingId: meetingInfo.meetingId,
          password: meetingPassword,
          realName: user.name || "",
          meetingTopic: topic
        },
        isvideooff,
        isaudiooff
      );
    } else if (avsdk === AVSDK.XYLINK) {
      await joinMeeting(avsdk, {
        meetingNumber: meetingInfo.meetingId.toString(),
        meetingPassword: meetingPassword,
        isvideooff: isvideooff,
        isaudiooff: isaudiooff
      });
    } else {
      return Promise.reject(new Error("未知会议类型" || ""));
    }
    clearTimeout(timeout);
    if (toUsers && toUsers.length > 0) {
      await handleMeetingSendMessage({
        avsdk,
        meetingInfo: {
          password: meetingPassword,
          meetingTopic: topic,
          meetingNumber: meetingInfo.meetingId.toString()
        },
        sessionState: SessionStateEnum.Call,
        toUsers
      });
      return true;
    } else {
      return true;
    }
  } catch (error) {
    console.error(error);
    clearTimeout(timeout);
    return Promise.reject(error);
  }
}

export function getStatus(avsdk: AVSDK) {
  if (avsdk === AVSDK.XYLINK) {
    return getXYLinkMeetStatus();
  } else if (avsdk === AVSDK.ZOOM) {
    return getZoomStatus();
  } else if (avsdk === AVSDK.JBRTC) {
    return getJDMeetStatus();
  } else if (avsdk === AVSDK.HUAWEI) {
    return getCloudLinkStatus() !== CloudLinkStatusEnum.FREE;
  } else {
    return Promise.reject(new Error("未知类型"));
  }
}
function getAvsdkByLive(avsdkLive: string) {
  let avsdk = AVSDK.JBRTC;
  switch (avsdkLive) {
    case "jbrtc":
    case "jrtc":
    case "jbrtcLive":
    case "jrtcLive":
      avsdk = AVSDK.JBRTC;
      break;
    default:
      break;
  }
  return avsdk;
}
function getLiveByAvsdk(avsdk: string, type?: string) {
  let live = avsdk;
  switch (avsdk) {
    case AVSDK.JBRTC:
      if (type === "voice") {
        live = "jrtcVoice";
      } else {
        live = "jrtcLive";
      }
      break;
    default:
      break;
  }
  return live;
}
export async function openRecord({
  meetingId,
  history,
  type = 0,
  action = "summaryDetail",
  scheduleId = ""
}: {
  meetingId: string;
  history: any;
  /** 0在线， 1线下纪要 */
  type: number;
  action?: string;
  scheduleId?: string;
}) {
  return new Promise((resolve) => {
    if (!isFocusEnv()) {
      const pmService = PostMessageService.getInstance(AVSDK.JBRTC) as PostMessageService;
      pmService
        .openServer(
          `${getAppEntry()}/meeting-home.html?avsdk=${
            AVSDK.JBRTC
          }&action=${action}&meetingId=${meetingId}&scheduleId=${scheduleId}&type=${type}`,
          {
            clientInfo: { name: `meeting-${AVSDK.JBRTC}` }
          }
        )
        .then(() => {
          updateMinutesOpenTime(meetingId);
          resolve(true);
        });
    } else if (!crossAppSwitch("threeApp")) {
      // 没有工作台，打开侧边栏meeting页
      history.push({
        pathname: "/meeting",
        state: {
          query: `action=${action}&meetingId=${meetingId}&scheduleId=${scheduleId}&type=${type}`
        }
      });
      updateMinutesOpenTime(meetingId);
      resolve(true);
    } else {
      history.push({
        pathname: "/third_apps"
      });
      // 临时解决方案
      const openApp = () => {
        bus.emit("openThirdApp", {
          applicationKey: getNoticeBot(AVSDK.JBRTC),
          homeUrl: `/jdmeet?action=${action}&meetingId=${meetingId}&scheduleId=${scheduleId}&type=${type}`,
          webviewKernel: WebviewKernel.NewWindow,
          name: "",
          icon: "",
          version: "1.0.0"
        });
        bus.off("thirdapp:ready", openApp);
        clearTimeout(timeout);
        clearTimeout(delay);
      };
      bus.once("thirdapp:ready", openApp);
      const delay = setTimeout(() => {
        openApp();
      }, 1000);
      const timeout = setTimeout(() => {
        bus.off("thirdapp:ready", openApp);
      }, 5000);
      updateMinutesOpenTime(meetingId);
      resolve(true);
    }
  });
}
export async function joinLive(
  avsdkLive: string,
  {
    liveCode,
    livePassword = "",
    name = "",
    icon = ""
  }: {
    liveCode: string;
    livePassword?: string;
    name?: string;
    icon?: string;
  },
  history: any
) {
  const avsdk = getAvsdkByLive(avsdkLive);
  if (isFocusEnv()) {
    const meetingStatus = await getStatus(avsdk);
    if (meetingStatus) {
      return Promise.reject(new Error("已经在会议中"));
    }
  } else {
    const pmService = PostMessageService.getInstance(AVSDK.JBRTC, false);
    if (pmService?.connected) {
      const status = await pmService.postMessage("MeetingStatus");
      if (status) {
        return Promise.reject(new Error("应用已打开"));
      }
    }
  }
  return new Promise((resolve, reject) => {
    queryLiveInfo({
      liveCode: liveCode,
      livePassword: livePassword
    }).then(([res, err]) => {
      if (!res || err) {
        reject(new Error(err || "未知错误"));
        return;
      }
      if (!isFocusEnv()) {
        if (avsdk === AVSDK.JBRTC) {
          const pmService = PostMessageService.getInstance(AVSDK.JBRTC) as PostMessageService;
          pmService
            .openServer(
              `${getAppEntry()}/meeting-home.html?avsdk=${avsdk}&liveUrl=${encodeURIComponent(
                res?.liveUrl || ""
              )}&topic=${res.conferenceTitle || ""}&liveCode=${liveCode}&action=live&meetingCode=${
                res.meetingCode
              }&meetingId=${res.meetingId}`,
              {
                clientInfo: { name: `meeting-${avsdk}` }
              }
            )
            .then(() => {
              resolve(true);
            });
        } else {
          reject(new Error("不支持非客户端环境"));
        }
      } else if (!crossAppSwitch("threeApp")) {
        // 没有工作台，打开侧边栏meeting页
        history.push({
          pathname: "/meeting",
          state: {
            query: `action=live&topic=${res.conferenceTitle}&liveUrl=${res?.liveUrl}&liveCode=${liveCode}&meetingId=${res.meetingId}&meetingCode=${res.meetingCode}`
          }
        });
        resolve(true);
      } else {
        history.push({
          pathname: "/third_apps"
        });
        // 临时解决方案
        const openApp = () => {
          bus.emit("openThirdApp", {
            applicationKey: getNoticeBot(avsdk),
            homeUrl: `/jdmeet?action=live&topic=${res.conferenceTitle}&liveUrl=${res?.liveUrl}&liveCode=${liveCode}&meetingId=${res.meetingId}&meetingCode=${res.meetingCode}`,
            webviewKernel: WebviewKernel.NewWindow,
            name,
            icon,
            version: "1.0.0"
          });
          bus.off("thirdapp:ready", openApp);
          clearTimeout(timeout);
          clearTimeout(delay);
        };
        bus.once("thirdapp:ready", openApp);
        const delay = setTimeout(() => {
          openApp();
        }, 1000);
        const timeout = setTimeout(() => {
          bus.off("thirdapp:ready", openApp);
        }, 5000);
        resolve(true);
      }
    });
  });
}

export async function joinMeeting(
  avsdkParam: AVSDK,
  {
    meetingNumber,
    meetingPassword = "",
    isaudiooff = true,
    isvideooff = true
  }: {
    meetingNumber: string;
    meetingPassword?: string;
    isaudiooff?: boolean;
    isvideooff?: boolean;
  }
) {
  let avsdk = avsdkParam;
  // 预检
  const [res, err] = await preJoin(meetingNumber);
  if (err) {
    return Promise.reject(new Error(err));
  }
  if (res?.code === PreJoinCode.LIMIT) {
    return Promise.reject(new Error(res?.msg || "人数已超限，无法加入"));
  }
  avsdk = getAvsdk(res.platform) as AVSDK;
  if (isFocusEnv()) {
    const meetingStatus = await getStatus(avsdk);
    if (meetingStatus) {
      if (avsdk === AVSDK.ZOOM) {
        const confirm = await syncConfirmNew(
          "有会议在进行中，是否强制结束现有会议并加入新的会议？",
          "提示",
          {}
        );
        if (confirm) {
          await leaveMeeting();
        } else {
          return Promise.reject(new Error(i18n.t("joinMeeting.There is a meeting going on")));
        }
      } else {
        return Promise.reject(new Error("已经在会议中"));
      }
    }
  } else {
    const openedPmService = PostMessageService.getInstance(AVSDK.JBRTC, false);
    if (openedPmService?.connected) {
      const status = await openedPmService.postMessage("MeetingStatus");
      if (status) {
        return Promise.reject(new Error("会议进行中"));
      }
    }
  }
  return new Promise((resolve, reject) => {
    if (!isFocusEnv()) {
      if (avsdk === AVSDK.JBRTC) {
        const pmService = PostMessageService.getInstance(AVSDK.JBRTC) as PostMessageService;
        pmService
          .openServer(
            `${getAppEntry()}/meeting-home.html?avsdk=${avsdk}&meetingNumber=${meetingNumber}&password=${meetingPassword}&action=join&isvideooff=${
              isvideooff ? "1" : "0"
            }&isaudiooff=${isaudiooff ? "1" : "0"}`,
            {
              clientInfo: { name: `meeting-${avsdk}` }
            }
          )
          .then((res: any) => {
            logger.debug("open res", res);
          });
        resolve(true);
      } else {
        reject(new Error("不支持非客户端环境"));
      }
      return;
    }
    ImService.getInstance()
      .getCurrentEmployee()
      .then((user) => {
        if (!user?.userId) {
          reject(new Error("获取当前用户失败"));
          return;
        }
        const timeout = setTimeout(() => {
          if (isFocusEnv()) {
            reject(new Error("加入会议超时"));
          }
        }, 60000);
        const userInfo = {
          app: user.app,
          pin: user.userId,
          teamId: user.teamId,
          name: user.nickName || user.name,
          avatar: user.avatar,
          titleName: user.titleName,
          deptName: user.deptName
        };
        function handle({ status, data, error }: { status: number; data: any; error: any }) {
          clearTimeout(timeout);
          if (status) {
            resolve(data);
          } else {
            if (isFocusEnv()) {
              reject(new Error(error || "加入会议失败"));
            }
          }
        }
        if (avsdk === AVSDK.XYLINK) {
          getConferenceByCode({
            meetingId: meetingNumber,
            platform: MeetingPlatform.XYLINK
          }).then(([info, err]: any) => {
            if (!info || err) {
              clearTimeout(timeout);
              reject(new Error(err));
              return;
            }
            setCurrentMeetingInfo(avsdk, info);
            FocusSDK.sendIpcMessage("xylink.joinMeeting", {
              meetingInfo: {
                meetingNumber: meetingNumber,
                topic: info.topic || "信创会议",
                controlPassword: info.controlPassword,
                password: meetingPassword,
                isvideooff: isvideooff,
                isaudiooff: isaudiooff
              },
              userInfo
            });
            FocusSDK.once("xylink:joinMeetingCb", handle);
          });
        } else if (avsdk === AVSDK.HUAWEI) {
          return joinCloudLink(user.userId, {
            password: meetingPassword,
            meetingNumber: meetingNumber,
            username: user.name || user.nickName || "",
            isvideooff: true,
            isaudiooff: true
          });
        } else if (avsdk === AVSDK.JBRTC) {
          getJRTCToken({
            currentEmployee: user
          }).then(([jrcToken, err]) => {
            if (err) {
              reject(new Error(err));
              return;
            }

            const userInfo = {
              token: jrcToken.token,
              deviceType: jrcToken.deviceType,
              jrtcUserId: jrcToken.jrtcUserId,
              appId: jrcToken.appId,
              app: user.app,
              pin: user.userId,
              teamId: user.teamId,
              name: user.name || user.nickName,
              avatar: user.avatar,
              deptName: user.deptName
            };
            FocusSDK.once("jdmeet:joinMeetingCb", handle);

            FocusSDK.sendIpcMessage("jdmeet.joinMeeting", {
              meetingInfo: {
                meetingNum: meetingNumber,
                password: meetingPassword,
                isvideooff: isvideooff,
                isaudiooff: isaudiooff
              },
              userInfo,
              env: {
                domain: jrcToken.domain,
                rtcDomain: jrcToken.rtcDomain
              }
            });
          });
        } else if (avsdk === AVSDK.ZOOM) {
          joinZoomMeeting(
            {
              meetingId: meetingNumber,
              password: meetingPassword,
              realName: user.name || ""
            },
            isvideooff,
            isaudiooff
          )
            .then((res) => {
              resolve(res);
            })
            .catch((e) => {
              console.error(e);
              reject(e);
            });
        } else {
          clearTimeout(timeout);
          reject(new Error("未知会议类型"));
        }
      });
  });
}

export async function replayMeetingMessage({
  sessionState,
  originMessage
}: {
  sessionState: SessionStateEnum;
  originMessage: any;
}) {
  const { ext = {} } = originMessage;
  const { fromUser } = ext;
  if (!fromUser.pin || !fromUser.app || !fromUser.teamId) {
    FocusSDK.printLog("send meeting message error: invalid user");
    return false;
  }
  const imService = ImService.getInstance();
  const messageId = generateMessageId();
  const userInfo: Partial<Employee> = await imService.getCurrentEmployee();
  const sessionId = imService.generateSingleSessionId(
    {
      app: userInfo.app,
      userId: userInfo.userId,
      teamId: userInfo.teamId
    } as any,
    {
      pin: fromUser.pin,
      app: fromUser.app,
      teamId: fromUser.teamId
    }
  );
  const newMessage: ChatMessageBody = {
    ext: {
      ...ext,
      clientType: getClientType(),
      fromUser: {
        name: userInfo.name,
        app: userInfo.app,
        pin: userInfo.userId,
        teamId: userInfo.teamId,
        avatar: userInfo.avatar
      },
      sessionState: sessionState,
      sessionType: 1
    },
    flag: 100,
    pushSms: 0,
    state: 0,
    noPush: 1,
    type: ChatMessageType.SYS,
    content: `${sessionStateContentMap[sessionState]}`
  };
  await imService.sendChatMessage(sessionId, messageId, newMessage, {
    skipCheckSession: true
  });
  return true;
}

export async function handleCreateSingleMeeting({
  from,
  to,
  avsdk,
  type
}: {
  from: BasicUserInfo;
  to: BasicUserInfo;
  avsdk: AVSDK;
  type?: string;
}) {
  if (from.pin === to.pin) {
    return Promise.reject(new Error("无法呼叫自己"));
  }
  if (!isFocusEnv()) {
    if (!WEB_SDK_LIST.includes(avsdk)) {
      return Promise.reject(new Error("不支持的会议类型"));
    }
  }
  if (isFocusEnv()) {
    const meetingStatus = await getStatus(avsdk);
    if (meetingStatus) {
      return Promise.reject(new Error(i18n.t("joinMeeting.There is a meeting going on")));
    }
  } else {
    const pmService = PostMessageService.getInstance(avsdk, false);
    if (pmService?.connected) {
      const status = await pmService.postMessage("MeetingStatus");
      if (status) {
        return Promise.reject(new Error(i18n.t("joinMeeting.There is a meeting going on")));
      }
    }
  }

  const [result, err] = await requestCreateMeeting({
    startTime: (new Date().getTime() + 5000).toString(),
    duration: 2,
    topic: i18n
      .t(type === "voice" ? "chat:voip.meetingTopicDesc" : "chat:joyMeeting.meetingTopicDesc")
      .replace("%from", from.name)
      .replace("%to", to.name),
    password: "",
    platform: getPlatform(avsdk),
    participantIds: [
      {
        realName: from.name,
        teamId: from.teamId,
        userId: from.pin,
        appId: from.app,
        headImg: from.avatar
      },
      {
        realName: to.name,
        teamId: to.teamId,
        userId: to.pin,
        appId: to.app,
        headImg: to.avatar
      }
    ]
  });
  if (err || !result) {
    return Promise.reject(new Error(err || "会议初始化失败"));
  }
  bus.emit("meeting:create-single-call", {
    avsdk,
    toUser: to,
    type,
    meetingInfo: result
  });
  return result;
}

export async function handleMeetingMessage(message: SysChatMessage, current: Employee) {
  log.debug("收到会议消息", message);
  if (handledMessage.length >= 10) {
    handledMessage.splice(0, handledMessage.length - 2);
  }
  if (handledMessage.includes(message.id)) {
    return;
  }
  handledMessage.push(message.id);
  const avsdk: AVSDK = message?.ext?.avsdk as AVSDK;
  if (!avsdk) {
    log.error("不支持的消息类型");
    return;
  }
  if (!isFocusEnv() && !WEB_SDK_LIST.includes(avsdk)) {
    return;
  }
  if (window.location.href.includes("?page=") && !window.location.href.includes("?page=chat")) {
    return;
  }

  let platform = FocusSDK.getDeviceInfo().platform;

  if (dayjs(message.timestamp).add(1, "minute").isBefore(dayjs())) {
    log.info("一分钟前的消息不处理", message);
    return;
  }
  const { ext = {} } = message;
  const sessionState = ext.sessionState as SessionStateEnum;
  logger.debug("sessionState=>", sessionState, avsdk);
  if (current.userId === message.from.pin) {
    if (avsdk === AVSDK.JBRTC) {
      toast.warn(`您${sessionStateContentMap[sessionState]}`);
      if (isFocusEnv()) {
        const stateName =
          sessionState === SessionStateEnum.UserReceive
            ? "receiveMeeting.answered"
            : "meeting.invitedClose";
        FocusSDK.sendIpcMessage(stateName, message.ext);
      } else {
        bus.emit("jdmeeting:hide-receive-modal");
      }
    }
    return;
  }
  bus.emit("meeting:receive-chat-message", message);
  const fromUser = ext.fromUser as BasicUserInfo;
  function handleInvited(data: any) {
    log.debug("invited cb ", data);
    if (sessionState === SessionStateEnum.Call && data.meetingStatus === "InMeeting") {
      replayMeetingMessage({
        sessionState: SessionStateEnum.Busy,
        originMessage: message
      });
    }
  }
  if (isFocusEnv() && sessionState === SessionStateEnum.Call) {
    const status = await getStatus(avsdk);
    if (status) {
      handleInvited({
        meetingStatus: "InMeeting"
      });
      return;
    }
  }
  FocusSDK.off("meeting:invitedCb", handleInvited).once("meeting:invitedCb", handleInvited);
  switch (avsdk) {
    case AVSDK.JBRTC:
      if (sessionState === SessionStateEnum.Call) {
        FocusSDK.sendIpcMessage("meeting.invited", message);
        if (!isFocusEnv()) {
          bus.emit("jdmeeting:show-receive-modal", message);
        }
      } else {
        if (sessionState === SessionStateEnum.Cancel) {
          FocusSDK.sendIpcMessage("meeting.invitedClose");
          bus.emit("jdmeeting:hide-receive-modal", message);
        }
        const notifyMsg = `${fromUser.name}${sessionStateContentMap[sessionState]}`;
        FocusSDK.sendIpcMessage("jdmeet.showNotification", notifyMsg);
        if (!isFocusEnv()) {
          PostMessageService.getInstance(AVSDK.JBRTC, false)?.postMessage(
            "showNotification",
            notifyMsg
          );
        }
        toast.info(notifyMsg);
      }
      break;
    case AVSDK.ZOOM:
      if (sessionState === SessionStateEnum.Call) {
        FocusSDK.sendIpcMessage("meeting.invited", message);
      } else if (sessionState === SessionStateEnum.Cancel) {
        FocusSDK.sendIpcMessage("meeting.invitedClose");
      } else if (
        sessionState === SessionStateEnum.Busy ||
        sessionState === SessionStateEnum.UserReject ||
        sessionState === SessionStateEnum.TIMEOUT
      ) {
        toast.info(`${fromUser.name}${sessionStateContentMap[sessionState]}`);
      }
      break;
    case AVSDK.XYLINK:
    case AVSDK.HUAWEI:
      if (platform === "win32") {
        if (sessionState === SessionStateEnum.Call) {
          FocusSDK.sendIpcMessage("meeting.invited", message);
        } else if (sessionState === SessionStateEnum.Cancel) {
          FocusSDK.sendIpcMessage("meeting.invitedClose");
        } else {
          if (
            sessionState === SessionStateEnum.Busy ||
            sessionState === SessionStateEnum.UserReject ||
            sessionState === SessionStateEnum.TIMEOUT
          ) {
            sendNoticeCard(message, ext.fromUser);
          }
          toast.info(`${fromUser.name}${sessionStateContentMap[sessionState]}`);
        }
      }
      break;
    default:
      break;
  }
}

export function getSdkType(avsdk: AVSDK) {
  if (avsdk === AVSDK.HUAWEI) {
    return "huawei";
  }
  if (avsdk === AVSDK.XYLINK) {
    return "xiaoyu";
  }
  if (avsdk === AVSDK.ZOOM) {
    return "zoom";
  }
  return "";
}

export async function handleLiveSendMessage(data: {
  avsdk: AVSDK;
  meetingInfo: LiveInfoType;
  currentEmployee: Employee;
  toUsers: BasicUserInfo[];
}) {
  const { avsdk, meetingInfo } = data;
  const toUsers = data.toUsers.filter((u) => u.app && u.pin && u.teamId);
  const deepLink =
    `openapp.jdfocus://jm/biz/appcenter/${deepLinkPath[avsdk]}?mparam=` +
    encodeURIComponent(
      JSON.stringify({
        avsdk: getLiveByAvsdk(avsdk),
        meetingTopic: meetingInfo.meetingTopic,
        liveCode: meetingInfo.liveCode,
        livePassword: meetingInfo.livePassword,
        conferenceTitle: meetingInfo.meetingTopic,
        meetingNumber: meetingInfo.meetingNumber,
        clientType: getClientType(),
        meetingPassword: meetingInfo.password,
        startTime: new Date().getTime().toString()
      })
    );
  sendConferenceCardMsg({
    noticeId: `eopen-push_${getNoticeBot(avsdk)}`,
    title: meetingInfo.meetingTopic,
    receivers: toUsers.map((user) => {
      return {
        app: user.app,
        pin: user.pin,
        teamId: user.teamId
      };
    }),
    meetingInfoReq: {
      meetingNumber: meetingInfo.liveCode,
      initiator: meetingInfo.initiator || "",
      inviteTime: meetingInfo.liveStartTime || "",
      type: 1
    },
    infox: {
      password: meetingInfo.password,
      deepLink,
      btnName: "观看直播",
      action: "joinmeeting",
      type: getLiveByAvsdk(avsdk)
    }
  });
}
export async function sendCardMessage(data: {
  avsdk: AVSDK;
  meetingInfo: LiveInfoType;
  toUsers: BasicUserInfo[];
}) {
  const imService = ImService.getInstance();
  const userInfo: Partial<Employee> = await imService.getCurrentEmployee();
  const toUsers = data.toUsers.filter((item: BasicUserInfo) => item.pin !== userInfo.userId);
  if (!toUsers || toUsers?.length === 0) {
    log.debug("noneed send");
    return;
  }

  const { avsdk, meetingInfo } = data;
  const sendResult = await Promise.all(
    toUsers.map((user) => {
      return new Promise((resolve) => {
        if (user.type !== SessionType.GROUP && (!user.pin || !user.app || !user.teamId)) {
          FocusSDK.printLog("send meeting message error: invalid user");
          resolve({
            message: "消息发送失败",
            status: 0
          });
          return;
        }
        const meetinglive_pull = {
          avsdk,
          meetingTopic: meetingInfo.meetingTopic, // 会议主题
          meetingNumber: meetingInfo.meetingNumber, // 会议号
          meetingPassword: meetingInfo.password, // 会议密码
          meetingStartTime: meetingInfo.liveStartTime, // 会议开始时间
          liveCode: meetingInfo.liveCode, // 直播间号
          livePassword: meetingInfo.livePassword, // 直播间密码
          liveUrl: meetingInfo.liveUrl, // 直播间观看地址
          conferenceTitle: meetingInfo.meetingTopic, // 直播间主题
          sharerName: userInfo.name // 分享人名字
        };
        const newMessage: ChatMessageBody = {
          type: ChatMessageType.TEMPLATE2,
          template: {
            nativeId: "meetinglive_pull"
          },
          code: 0,
          data: [
            {
              meetinglive_pull: meetinglive_pull,
              type: 0
            }
          ]
        };
        const messageId = generateMessageId();
        let sessionId = user.pin;
        if (user.type !== SessionType.GROUP) {
          sessionId = imService.generateSingleSessionId(
            {
              app: userInfo.app,
              userId: userInfo.userId,
              teamId: userInfo.teamId
            } as any,
            {
              pin: user.pin,
              app: user.app,
              teamId: user.teamId
            }
          );
        }
        imService
          .sendChatMessage(sessionId, messageId, newMessage, {
            skipCheckSession: true
          })
          .then((res: any) => {
            logger.debug("send chat card message ok: ", res);
            resolve({
              message: "消息发送成功",
              status: 1
            });
          })
          .catch((e: any) => {
            logger.error("send chat card message err", e);
            resolve({
              message: "消息发送失败",
              status: 0,
              error: e
            });
          });
      });
    })
  );
  return sendResult;
}

export function parseEmployToBasicUserInfo(currentEmploy: Employee) {
  return {
    pin: currentEmploy?.userId,
    teamId: currentEmploy?.teamId,
    name: currentEmploy?.name,
    app: currentEmploy?.app,
    avatar: currentEmploy?.avatar
  };
}

export async function handleMeetingSendMessage(data: {
  avsdk: AVSDK;
  meetingInfo: MeetingInfoType;
  sessionState: SessionStateEnum;
  toUsers: BasicUserInfo[];
  type?: string;
  projectType?: number;
}) {
  log.debug("handleMeetingSendMessage", data);
  if (!isFocusEnv() && !WEB_SDK_LIST.includes(data.avsdk)) {
    return;
  }
  const imService = ImService.getInstance();
  const userInfo: Partial<Employee> = await imService.getCurrentEmployee();
  const { avsdk, sessionState, meetingInfo } = data;
  const toUsers = data.toUsers;
  // .filter((item: BasicUserInfo) => item.pin !== userInfo.userId);
  // if (!toUsers || toUsers?.length === 0) {
  //   log.debug("noneed send");
  //   return;
  // }
  const body = {
    ext: {
      displayName: "",
      avsdk,
      projectType: data.projectType || 0, // 1 是债权人会议，不发送卡片。只有行业ME的租户是
      fromUser: {
        pin: userInfo.userId || "",
        teamId: userInfo.teamId || "",
        name: userInfo.name || "",
        app: userInfo.app || "",
        avatar: userInfo.avatar || ""
      },
      meetingID: meetingInfo.meetingID || "",
      meetingTopic: meetingInfo.meetingTopic || "",
      meetingDuration: 120,
      meetingNumber: String(meetingInfo.meetingNumber),
      enableMicphone: 0,
      clientType: getClientType(),
      meetingPassword: meetingInfo.password || "",
      sessionState,
      sessionType: sessionState === SessionStateEnum.UserReject ? 1 : 0,
      startTime: new Date().getTime().toString(),
      enableJRTCVoice: data.type === "voice" ? 1 : 0
    },
    flag: 100,
    state: 0,
    noPush: sessionState === SessionStateEnum.Call ? 0 : 1,
    pushSms: 0,
    type: ChatMessageType.SYS,
    content: meetingInfo.meetingTopic
  };
  FocusSDK.sendIpcMessage("voip.sendVoipCall", {
    toUsers: toUsers
      .filter((user) => user.app && user.teamId && user.pin)
      .map((item) => {
        return {
          ...item,
          userId: item.pin,
          appId: item.app
        };
      }),
    body
  });

  const sendResult: {
    message: string;
    status: number;
    error: string;
  }[] = await Promise.all(
    toUsers.map((user) => {
      return new Promise<any>((resolve) => {
        if (!user.pin || !user.app || !user.teamId) {
          FocusSDK.printLog("send meeting message error: invalid user");
          resolve({
            message: "消息发送失败",
            status: 0
          });
          return;
        }
        const sessionId = imService.generateSingleSessionId(
          {
            app: userInfo.app,
            userId: userInfo.userId,
            teamId: userInfo.teamId
          } as any,
          {
            pin: user.pin,
            app: user.app,
            teamId: user.teamId
          }
        );
        const newMessage = {
          sessionId,
          ...body,
          requestData: {
            sessionId
          },
          timestamp: new Date().getTime(),
          type: ChatMessageType.SYS,
          flag: 100
        } as any;
        const messageId = generateMessageId();
        imService
          .sendChatMessage(sessionId, messageId, newMessage, {
            skipCheckSession: true
          })
          .then((res: any) => {
            logger.debug("send chat message ok: ", res);
            if (res) {
              resolve({
                message: "消息发送成功",
                status: 1
              });
            } else {
              resolve({
                message: "消息发送失败",
                status: 0
              });
            }
          })
          .catch((e: any) => {
            logger.error("send chat message err", e);
            resolve({
              message: "消息发送失败",
              status: 0,
              error: e
            });
          });
      });
    })
  );
  if (sendResult.length === 1 && sendResult[0].status === 0) {
    return Promise.reject(new Error("消息发送失败"));
  }
  if (sessionState === SessionStateEnum.Call) {
    cache.telCall &&
      conferenceCall({
        userIds: toUsers.map((item: any) => item.pin),
        meetingId: body.ext.meetingNumber.toString(),
        password: body.ext.meetingPassword,
        topic: body.ext.meetingTopic,
        sdkType: getSdkType(avsdk)
      }).then(([, err]) => {
        if (err) {
          logger.error(err);
        }
      });
    if (
      avsdk === AVSDK.HUAWEI ||
      avsdk === AVSDK.XYLINK ||
      avsdk === AVSDK.JBRTC ||
      avsdk === AVSDK.ZOOM
    ) {
      // sendNoticeCard(body, toUsers, body.ext.fromUser);
      const ext = body.ext;
      sendConferenceCardMsg({
        noticeId:
          data.type === "voice" ? CHAT_NOTICE.VOICE_PIN : `eopen-push_${getNoticeBot(avsdk)}`,
        title:
          data.type === "voice"
            ? ext.meetingTopic.replace("视频会议", "语音通话")
            : ext.meetingTopic,
        receivers: toUsers
          .filter((user) => user.app && user.pin && user.teamId)
          .map((user) => {
            return {
              app: user.app,
              pin: user.pin,
              teamId: user.teamId
            };
          }),
        meetingInfoReq: {
          meetingNumber: ext.meetingNumber,
          initiator: ext.fromUser.name || "",
          inviteTime: dayjs().format("YYYY-MM-DD HH:mm:ss")
        },
        infox: {
          password: ext.meetingPassword,
          deepLink: generateRequestCardMsg(ext.fromUser, toUsers, body).infox.deepLink,
          btnName: data.type === "voice" ? "立即呼叫" : "立即入会",
          action: "joinmeeting",
          type: data.type === "voice" ? "jrtcVoice" : avsdk
        }
      });
    }
  }
  return sendResult;
}

export async function sendNoticeCard(body: any, toUsers: any, fromUser?: any) {
  const { ext } = body;
  const avsdk: AVSDK = ext.avsdk;
  if (!avsdk) return;
  let from = fromUser;
  if (!fromUser) {
    const userInfo = await ImService.getInstance().getCurrentEmployee();
    from = {
      pin: userInfo.userId,
      teamId: userInfo.teamId,
      name: userInfo.name,
      app: userInfo.app,
      avatar: userInfo.avatar
    };
  }
  ext.fromUser = from;
  const appPathMap = {
    [AVSDK.HUAWEI]: "cloudlink",
    [AVSDK.ZOOM]: "joymeeting",
    [AVSDK.JBRTC]: "joymeeting",
    [AVSDK.XYLINK]: "joymeeting"
  };
  const deepLink =
    `openapp.jdfocus://jm/biz/appcenter/${appPathMap[avsdk]}?mparam=` +
    encodeURIComponent(
      JSON.stringify({
        device: null,
        ...ext,
        fromUser: {
          clientType: getClientType(),
          info: null,
          intro: null,
          nameIndex: null,
          xToken: null,
          ...from
        }
      })
    );
  const msg = {
    title: `${ext.meetingTopic}`,
    content: `会议号：${ext.meetingNumber}`,
    extend: {
      url: ""
    },
    from: fromUser,
    imgUrl: "",
    infox: {
      ...ext,
      imgUrl: "",
      deepLink
    },
    tos: toUsers
  };
  sendNoticeCardMessage(msg, getNoticeBot(avsdk));
}

export const MEETING_APPLICATION_ID: any = {
  ZOOM: "yi24xAt5pomCb8Xgw1hD",
  JBRTC: "PloJFyzbij4O26HXbjfX",
  JBRTC_SUMMARY: "NNFg1oeB3EQ1SzwLS4co",
  HUAWEI: "pkYb8mVGgUxRx0u31kKJ",
  XYLINK: "V2vLdYfdDPMiKWt64aUD"
};

export function getApplicationId(avsdk: AVSDK, param?: string) {
  switch (avsdk) {
    case AVSDK.ZOOM:
      return MEETING_APPLICATION_ID.ZOOM;
    case AVSDK.JBRTC:
      if (param === "summary") {
        return MEETING_APPLICATION_ID.JBRTC_SUMMARY;
      }
      return MEETING_APPLICATION_ID.JBRTC;
    case AVSDK.HUAWEI:
      return MEETING_APPLICATION_ID.HUAWEI;
    case AVSDK.XYLINK:
      return MEETING_APPLICATION_ID.XYLINK;
    default:
      break;
  }
  return "";
}

export function generateRequestCardMsg(
  fromUser: BasicUserInfo,
  toUsers: BasicUserInfo[],
  message: any
) {
  const { ext } = message;
  const avsdk: AVSDK = ext.avsdk;
  // if (!avsdk) {
  //     return '无效的AVSDK';
  // }
  const { meetingNumber, meetingTopic } = ext;

  const deepLink =
    `openapp.jdfocus://${DeeplinkPathEnum.AppCenter}/${deepLinkPath[avsdk]}?mparam=` +
    encodeURIComponent(
      JSON.stringify({
        device: null,
        displayName: null,
        enableMicphone: 0,
        enableVideo: 0,
        ...ext,
        fromUser: {
          clientType: getClientType(),
          info: null,
          intro: null,
          nameIndex: null,
          xToken: null,
          ...fromUser
        }
      })
    );
  return {
    title: `${meetingTopic}`,
    content: `${i18n.t("common:joinMeeting.meetingNumber")}: ${meetingNumber}`,
    extend: {
      url: ""
    },
    from: fromUser,
    imgUrl: "",
    infox: {
      ...ext,
      imgUrl: "",
      deepLink
    },
    tos: toUsers.map((item: any) => {
      return {
        ...item,
        pin: item.pin || item.userId,
        name: item.name || item.realName
      };
    })
  };
}
export function sendToWebView(type: string, data?: any) {
  if (isFocusEnv()) {
    FocusSDK.sendGlobalWebviewMessage(`${type}:cb`, data);
  } else {
    bus.emit(`${type}:cb`, data);
  }
}
export function sendToWebViewEvent(eventName: string, avsdk: AVSDK, data?: any) {
  if (isFocusEnv()) {
    FocusSDK.sendGlobalWebviewMessage(eventName, data);
  } else {
    const pmService = PostMessageService.getInstance(avsdk) as PostMessageService;
    pmService.postMessage(eventName, data);
  }
}

export function getUnitName(employee: Partial<Employee>) {
  const result = [];

  let unitName = "暂未填写单位";
  if (employee.unitName) {
    unitName = employee.unitName;
  }
  if (unitName) {
    result.push(unitName);
  }

  let titleName = employee.titleName;
  if (!titleName || titleName === "暂未填写") {
    titleName = "暂未填写职务";
  }
  if (titleName) {
    result.push(titleName);
  }

  return result.join("-");
}

export function getNumber(prefix: string, content: string) {
  return content.match(new RegExp(`(?<=${prefix})\\s*\\d*[0-9]`))?.[0];
}

export function compressString(content: string) {
  return content.replace(/\n|\s+/g, "");
}

export function messageToObj(content: string) {
  const obj = content
    .replace(/ /g, "")
    .split("\n")
    .filter((item) => item.indexOf("：") >= 0);
  return obj
    .map((item) => {
      const idx = item.indexOf("：");
      if (idx) {
        const value = item.substring(idx + 1);
        if (value) {
          return {
            key: item.substring(0, idx),
            value
          };
        }
      }
      return null;
    })
    .filter((item) => !!item);
}

export function isMeetingInviteMsg(content: string) {
  if (!content) {
    return false;
  }
  if (content.indexOf("点击链接直接加入会议：") >= 0) {
    const _content = compressString(content);
    if (_content.indexOf("会议链接：点击链接直接加入会议：3.cn/")) {
      const meetingNumber = getNumber("会议号：", _content);
      if (meetingNumber && meetingNumber.length === 9) {
        return true;
      }
    }
  }
  return false;
}

export async function downloadFile(params: {
  url: string;
  body?: any;
  fileName: string;
  token: string;
}) {
  return new Promise((resolve, reject) => {
    Axios.post(params.url, params.body || {}, {
      responseType: "blob",
      headers: { token: params.token, "content-type": "application/json;charset=UTF-8" }
    })
      .then((res) => {
        const { headers, data } = res;
        if (headers["content-type"] === "application/force-download") {
          const a = document.createElement("a");
          document.body.appendChild(a);
          let blobUrl = window.URL.createObjectURL(new Blob([data]));
          a.href = blobUrl;
          a.download = params.fileName;
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(blobUrl);
          resolve(true);
        } else {
          try {
            data.text().then((data: any) => {
              try {
                const { msg: resMsg } = JSON.parse(data);
                reject(new Error(resMsg));
              } catch (error) {
                console.error(error);
                reject(new Error("操作失败"));
              }
            });
          } catch (error) {
            reject(new Error("操作失败"));
          }
        }
      })
      .catch((error) => {
        log.error("request error", error);
        if (error.response) {
          try {
            error.response.data.text().then((data: any) => {
              try {
                const { message: resMsg } = JSON.parse(data);
                reject(new Error(resMsg));
              } catch (error) {
                console.error(error);
                reject(new Error("操作失败"));
              }
            });
          } catch (error) {
            console.error(error);
            reject(new Error("操作失败"));
          }
          return;
        }
        reject(new Error("操作失败"));
      });
  });
}
